import { Container, Table, Row, Col } from "reactstrap";
import { Header } from ".";
import _ from "lodash";

export default function Inspections() {
  return (
    <Container>
      <Header />
      <Row className="my-3">
        <Col>
          <h3 className="d-flex justify-content-center my-3">Inspections</h3>
        </Col>
      </Row>
      <Row>
        <Table>
          <thead>
            <tr>
              <th>Shed Serial Number</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>#901384</td>
              <td>01/01/2020</td>
            </tr>
            <tr>
              <td>#987654</td>
              <td>02/02/2020</td>
            </tr>
            <tr>
              <td>#757575</td>
              <td>03/30/2021</td>
            </tr>
            <tr>
              <td>#543654</td>
              <td>04/06/2021</td>
            </tr>
          </tbody>
        </Table>
      </Row>
    </Container>
  );
}
